import {
  useEditorSlideUpdateInstructionsBarVisibility,
  useEditorSlideUpdateQrCodeVisibility,
} from '@mentimeter/editor-data-hooks';
import { type QuestionWithSlide } from '@mentimeter/editor-schema/api-types-overrides';
import { useEffect } from 'react';
import { getOnboardingSeenFromLocalStorage } from '../data-handler/EditorTourDataHandler';

export const useDisableJoinInstructions = (
  seriesId: string,
  activeQuestion: QuestionWithSlide,
) => {
  const hasSeenForcefulEditorTour = getOnboardingSeenFromLocalStorage();
  const updateQrCodeVisibility = useEditorSlideUpdateQrCodeVisibility({
    seriesId,
    questionId: activeQuestion.id,
  });
  const updateInstructionsBarVisibility =
    useEditorSlideUpdateInstructionsBarVisibility({
      seriesId,
    });

  useEffect(() => {
    if (activeQuestion?.slideId && !hasSeenForcefulEditorTour) {
      updateInstructionsBarVisibility({
        slideId: activeQuestion.slideId,
        hideInstructionsBar: true,
      });
      updateQrCodeVisibility({
        slideId: activeQuestion.slideId,
        hideQrCode: true,
      });
    }
  }, [
    activeQuestion?.slideId,
    hasSeenForcefulEditorTour,
    updateInstructionsBarVisibility,
    updateQrCodeVisibility,
  ]);
};
